var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"outlined":"","tile":"","disabled":_vm.isCalculating,"loading":_vm.isCalculating},on:{"click":_vm.validate}},[_vm._v(" "+_vm._s(`${_vm.numberOfResults} `)+" "+_vm._s(_vm.$tc('search.filter.display-results', _vm.numberOfResults))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }